import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../environments/environment';
import { TitleService } from './stp/stp-app-material/layouts/services/title.service';
import { SsoAuthService } from './ecan/sso-auth.service';
import { AppConfigurationService } from './stp/stp-app/common';
import { EcNumberLinkingService } from './authentication/services/ecNumberLinkingService.service';
import { Router, GuardsCheckEnd, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { AuthService } from './authentication/services/auth.service';
import { BusyService } from './stp/stp-app-material';
import { ProfileUpdateService } from './authentication/services/profile-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

  versionInfo = environment.versionInfo;
  appName = environment.appName;
  ecanProfileUrl = null;
  resourcesUrl = null;

  public isAuthenticated = false;

  public get authError() {
    // Hide auth errors when logging in
    if (this.router.url.endsWith('/login')) {
      return '';
    }
    return this.authService.authError;
  }

  constructor(
    titleService: TitleService,
    private ssoAuthService: SsoAuthService,
    private authService: AuthService,
    private appConfig: AppConfigurationService,
    private ecNumberLinkingService: EcNumberLinkingService,
    private profileUpdateService: ProfileUpdateService,
    private busyService: BusyService,
    private router: Router
  ) {
    titleService.setAppName(environment.appName);
    this.ecanProfileUrl = appConfig.getValue('ecanProfileUrl');
    this.resourcesUrl = appConfig.getValue('resourcesUrl');
  }

  ngOnInit(): void {
    this.authService.init();
    this.ecNumberLinkingService.init();
    this.profileUpdateService.init();

    this.busyService.stopFullPage();

    this.spinnerOnRouteChange();

    // We've initialised all auth-related services.
    // If we entered at a route other than '/', maintain session.
    this.authService.tryImplicitOrRequireLogin();
  }

  private spinnerOnRouteChange() {
    this.router.events
      .subscribe(event => {
        if (event instanceof GuardsCheckEnd) {
          this.busyService.startFullPage();
        }
        if (event instanceof NavigationEnd
          || event instanceof NavigationCancel
          || event instanceof NavigationError) {
          this.busyService.stopFullPage();
          this.isAuthenticated = this.ssoAuthService.isAuthenticated();
        }
      });
  }

  public logout() {
    this.ssoAuthService.logout(this.appConfig.getValue('webUrl') + '/login');
  }
}
